import { wpApi } from "./axios";

let settingsCache = null;

export async function getStoreSettings() {
    if (settingsCache) return settingsCache;
    const response = await wpApi.get("/headless/v1/store-settings");
    settingsCache = response.data;
    return settingsCache;
}
